import { styled } from '@mui/material';
export const BreadcrumbsInnerContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    paddingBottom: theme.spacing(1),
}));
